// useInitAxiosErrorHandler.ts
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { openSnackbar } from 'store/slices/snackbar';
import { setAxiosErrorHandler } from 'utils/axios';

export const useInitAxiosErrorHandler = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        setAxiosErrorHandler((type) => {
            if (type === 'network') {
                dispatch(
                    openSnackbar({
                        message: 'Connection error. Check your network permissions.',
                        variant: 'error'
                    })
                );
            } else if (type === 'permissions') {
                dispatch(
                    openSnackbar({
                        message: "You're not allowed to view this content. Check your user permissions.",
                        variant: 'error'
                    })
                );
            }
        });
    }, [dispatch]);
};
